import React from "react";
import { motion } from "framer-motion";

const SplashScreen = () => {
  return (
    <motion.div
      className="fixed inset-0 z-[200] bg-black flex items-center justify-center"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.8, ease: "easeInOut" }}
      data-testid="splash-screen"
    >
      {/* Logo container */}
      <motion.div
        className="relative z-10 flex flex-col items-center"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3, duration: 1, ease: "easeOut" }}
      >
        {/* Text Logo */}
        <h1 
          className="font-['Playfair_Display'] text-4xl sm:text-5xl md:text-6xl text-white tracking-[0.15em] font-light"
          data-testid="splash-logo"
        >
          INTROZZI
        </h1>
        {/* Gold underline */}
        <motion.div 
          className="mt-4 h-[1px] bg-[#C5A059]"
          initial={{ width: 0 }}
          animate={{ width: 80 }}
          transition={{ delay: 0.8, duration: 0.8, ease: "easeOut" }}
        />
      </motion.div>

      {/* Subtle vignette effect */}
      <div className="absolute inset-0 pointer-events-none" 
           style={{
             background: "radial-gradient(ellipse at center, transparent 0%, black 100%)",
             opacity: 0.3
           }} 
      />
    </motion.div>
  );
};

export default SplashScreen;
